import React, {useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import { resetPassword } from "../../../store/entities/Auth/Auth.actions";
import { useHistory } from "react-router-dom";
import URLS from "../../../config/navigation";
import ResetPasswordForm from "../../../components/Auth/ResetPasswordForm";
import queryString from "query-string";
import HelmetComponent from "../../../components/Common/Helmet";
import TitleComponent from "../../../components/Auth/TitleContainer";
const ResetPassword = (props) => {
   
  const dispatch = useDispatch();
  const history = useHistory();
  const [resetCode, setResetCode] = useState(null);

  const callback = () => {
    history.push(URLS.AUTH.SIGNIN)
  }

  useEffect(() => {
    const { code } = queryString.parse(props.location.search);
    setResetCode(code);
  }, [])

  const handleSubmitResetPassword = (values, { setSubmitting }) => {
    dispatch(resetPassword({ ...values, code: resetCode, callback }));
  };

  return (
    <div className={"container"}>
      <HelmetComponent title="Reset your Password - TeachOn"/>
    
      <TitleComponent title={"Please enter a new password"} />
      <div className={"formContainer"}>
        <ResetPasswordForm handleSubmit={handleSubmitResetPassword} />
       
      </div>
    </div>
  );
}

export default ResetPassword;
